module.exports = {
	"v": "5.7.4",
	"fr": 60,
	"ip": 0,
	"op": 316,
	"w": 1200,
	"h": 1200,
	"nm": "New kind of buy_spin",
	"ddd": 1,
	"assets": [],
	"fonts": {
		"list": [
			{
				"fName": "ABCMonumentGroteskSemi-Mono-Regular",
				"fFamily": "ABC Monument Grotesk Semi-Mono",
				"fStyle": "Regular",
				"ascent": 69.9996948242188
			},
			{
				"fName": "LabilGrotesk-Bold",
				"fFamily": "Labil Grotesk",
				"fStyle": "Bold",
				"ascent": 69.9996948242188
			}
		]
	},
	"layers": [
		{
			"ddd": 1,
			"ind": 1,
			"ty": 5,
			"nm": "SEE HOW",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"rx": {
					"a": 0,
					"k": 0,
					"ix": 8
				},
				"ry": {
					"a": 0,
					"k": 0,
					"ix": 9
				},
				"rz": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"or": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 7
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 264,
							"s": [
								598.229,
								866,
								0
							],
							"to": [
								0,
								11.333,
								0
							],
							"ti": [
								0,
								-11.333,
								0
							]
						},
						{
							"t": 306,
							"s": [
								598.229,
								934,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"sz": [
									904,
									132
								],
								"ps": [
									-452,
									-26
								],
								"s": 129,
								"f": "LabilGrotesk-Bold",
								"t": "SEE HOW",
								"j": 2,
								"tr": 0,
								"lh": 154.8,
								"ls": 0,
								"fc": [
									0,
									0.275,
									1
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": []
			},
			"ip": 264,
			"op": 316,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 1,
			"ind": 2,
			"ty": 1,
			"nm": "Spotin blue",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.667
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0
								]
							},
							"t": 264,
							"s": [
								100
							]
						},
						{
							"t": 306,
							"s": [
								100
							]
						}
					],
					"ix": 11
				},
				"rx": {
					"a": 0,
					"k": 0,
					"ix": 8
				},
				"ry": {
					"a": 0,
					"k": 0,
					"ix": 9
				},
				"rz": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"or": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 7
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 264,
							"s": [
								600,
								915,
								0
							],
							"to": [
								0,
								10.833,
								0
							],
							"ti": [
								0,
								-10.833,
								0
							]
						},
						{
							"t": 306,
							"s": [
								600,
								980,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						600,
						-39,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						17,
						17,
						17
					],
					"ix": 6
				}
			},
			"ao": 0,
			"hasMask": true,
			"masksProperties": [
				{
					"inv": false,
					"mode": "f",
					"pt": {
						"a": 0,
						"k": {
							"i": [
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								]
							],
							"o": [
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								],
								[
									0,
									0
								]
							],
							"v": [
								[
									858.444,
									875.727
								],
								[
									611,
									1123.17
								],
								[
									611,
									374.755
								],
								[
									589,
									374.755
								],
								[
									589,
									1123.17
								],
								[
									341.556,
									875.727
								],
								[
									326,
									891.283
								],
								[
									599.962,
									1165.245
								],
								[
									600,
									1165.207
								],
								[
									600.038,
									1165.245
								],
								[
									874,
									891.283
								]
							],
							"c": true
						},
						"ix": 1
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 3
					},
					"x": {
						"a": 0,
						"k": 0,
						"ix": 4
					},
					"nm": "Mask 1"
				}
			],
			"sw": 1200,
			"sh": 1200,
			"sc": "#0046ff",
			"ip": 264,
			"op": 316,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 1,
			"ind": 3,
			"ty": 5,
			"nm": "A NEW  KIND OF  BUY",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"rx": {
					"a": 0,
					"k": 0,
					"ix": 8
				},
				"ry": {
					"a": 0,
					"k": 0,
					"ix": 9,
					"x": "var $bm_rt;\n$bm_rt = thisComp.layer('Shape Layer 1').transform.yRotation;"
				},
				"rz": {
					"a": 0,
					"k": -9,
					"ix": 10
				},
				"or": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 7
				},
				"p": {
					"a": 0,
					"k": [
						596.837,
						601.031,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						-118,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"sz": [
									1108,
									792
								],
								"ps": [
									-554,
									-396
								],
								"s": 234,
								"f": "LabilGrotesk-Bold",
								"t": "A NEW \u0003KIND OF \u0003BUY",
								"j": 2,
								"tr": 0,
								"lh": 194,
								"ls": 0,
								"fc": [
									0,
									0.275,
									1
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": []
			},
			"ip": 0,
			"op": 94,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 1,
			"ind": 4,
			"ty": 5,
			"nm": "Fairer. Betterer. Link-free-er.",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"rx": {
					"a": 0,
					"k": 0,
					"ix": 8
				},
				"ry": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 93,
							"s": [
								-90
							]
						},
						{
							"t": 179,
							"s": [
								0
							]
						}
					],
					"ix": 9
				},
				"rz": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.667
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"t": 95,
							"s": [
								281
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"t": 239,
							"s": [
								373
							]
						},
						{
							"t": 287,
							"s": [
								500
							]
						}
					],
					"ix": 10
				},
				"or": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 7
				},
				"p": {
					"a": 0,
					"k": [
						601.291,
						603.251,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						-3,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						286.739,
						286.739,
						286.739
					],
					"ix": 6
				}
			},
			"ao": 0,
			"hasMask": true,
			"masksProperties": [
				{
					"inv": false,
					"mode": "n",
					"pt": {
						"a": 0,
						"k": {
							"i": [
								[
									99.357,
									0
								],
								[
									0,
									-99.357
								],
								[
									-99.357,
									0
								],
								[
									0,
									99.357
								]
							],
							"o": [
								[
									-99.357,
									0
								],
								[
									0,
									99.357
								],
								[
									99.357,
									0
								],
								[
									0,
									-99.357
								]
							],
							"v": [
								[
									-0.121,
									-184.085
								],
								[
									-180.023,
									-4.182
								],
								[
									-0.121,
									175.72
								],
								[
									179.782,
									-4.182
								]
							],
							"c": true
						},
						"ix": 1
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 3
					},
					"x": {
						"a": 0,
						"k": 0,
						"ix": 4
					},
					"nm": "Mask 1"
				}
			],
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 19,
								"f": "ABCMonumentGroteskSemi-Mono-Regular",
								"t": "Fairer. Betterer. Link-free-er.",
								"j": 2,
								"tr": 0,
								"lh": 22.8,
								"ls": 0,
								"fc": [
									0,
									0.275,
									1
								]
							},
							"t": 0
						}
					]
				},
				"p": {
					"m": 0,
					"f": {
						"a": 0,
						"k": 0,
						"ix": 5
					},
					"l": {
						"a": 0,
						"k": 0,
						"ix": 6
					},
					"a": 0,
					"p": 1,
					"r": 0
				},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": [
					{
						"nm": "Animator 1",
						"s": {
							"t": 0,
							"xe": {
								"a": 0,
								"k": 0,
								"ix": 7
							},
							"ne": {
								"a": 0,
								"k": 0,
								"ix": 8
							},
							"a": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"b": 1,
							"rn": 0,
							"sh": 1,
							"s": {
								"a": 0,
								"k": 100,
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"t": 249,
										"s": [
											100
										]
									},
									{
										"t": 287,
										"s": [
											0
										]
									}
								],
								"ix": 2
							},
							"r": 1
						},
						"a": {
							"o": {
								"a": 0,
								"k": 0,
								"ix": 9
							}
						}
					}
				]
			},
			"ip": 94,
			"op": 316,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 1,
			"ind": 5,
			"ty": 4,
			"nm": "Shape Layer 1",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"rx": {
					"a": 0,
					"k": 0,
					"ix": 8
				},
				"ry": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.073
								],
								"y": [
									0
								]
							},
							"t": 0,
							"s": [
								0
							]
						},
						{
							"t": 179,
							"s": [
								180
							]
						}
					],
					"ix": 9
				},
				"rz": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"or": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 7
				},
				"p": {
					"a": 0,
					"k": [
						600,
						600,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						150.617,
						150.617,
						150.617
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											200.121,
											0
										],
										[
											0,
											-200.121
										],
										[
											-200.121,
											0
										],
										[
											0,
											200.121
										]
									],
									"o": [
										[
											-200.121,
											0
										],
										[
											0,
											200.121
										],
										[
											200.121,
											0
										],
										[
											0,
											-200.121
										]
									],
									"v": [
										[
											0,
											-362.352
										],
										[
											-362.352,
											0
										],
										[
											0,
											362.352
										],
										[
											362.352,
											0
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 250,
								"s": [
									0
								]
							},
							{
								"t": 274,
								"s": [
									100
								]
							}
						],
						"ix": 1
					},
					"e": {
						"a": 0,
						"k": 100,
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				}
			],
			"ip": 0,
			"op": 316,
			"st": 0,
			"bm": 0
		}
	],
	"markers": [],
	"chars": [
		{
			"ch": "F",
			"size": 19,
			"style": "Regular",
			"w": 59.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												19.235,
												0
											],
											[
												19.235,
												-31.522
											],
											[
												50.958,
												-31.522
											],
											[
												50.958,
												-39.679
											],
											[
												19.235,
												-39.679
											],
											[
												19.235,
												-62.338
											],
											[
												54.684,
												-62.338
											],
											[
												54.684,
												-70.496
											],
											[
												10.172,
												-70.496
											],
											[
												10.172,
												0
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "F",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "F",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "a",
			"size": 19,
			"style": "Regular",
			"w": 58,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0.806,
												0
											],
											[
												0,
												2.618
											],
											[
												0,
												0
											],
											[
												12.689,
												0
											],
											[
												3.625,
												-2.417
											],
											[
												0.201,
												-6.042
											],
											[
												0,
												0
											],
											[
												-8.762,
												0
											],
											[
												-1.41,
												-2.014
											],
											[
												0,
												-4.532
											],
											[
												0,
												0
											],
											[
												0,
												-10.876
											],
											[
												-8.459,
												0
											],
											[
												-2.82,
												5.74
											],
											[
												-5.539,
												0
											],
											[
												-1.913,
												0.302
											]
										],
										"o": [
											[
												-1.309,
												0.302
											],
											[
												-2.921,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-10.977
											],
											[
												-6.445,
												0
											],
											[
												-3.928,
												2.618
											],
											[
												0,
												0
											],
											[
												0,
												-7.654
											],
											[
												4.431,
												0
											],
											[
												1.511,
												2.115
											],
											[
												0,
												0
											],
											[
												-7.956,
												1.511
											],
											[
												0,
												9.869
											],
											[
												8.56,
												0
											],
											[
												0.504,
												5.237
											],
											[
												2.014,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												54.886,
												-7.452
											],
											[
												51.965,
												-7.05
											],
											[
												49.045,
												-10.876
											],
											[
												49.045,
												-34.946
											],
											[
												29.91,
												-51.562
											],
											[
												14.502,
												-47.836
											],
											[
												8.258,
												-34.744
											],
											[
												17.12,
												-33.536
											],
											[
												29.407,
												-44.412
											],
											[
												38.571,
												-41.089
											],
											[
												40.283,
												-31.924
											],
											[
												23.666,
												-28.702
											],
											[
												6.546,
												-13.293
											],
											[
												23.465,
												1.208
											],
											[
												40.384,
												-7.452
											],
											[
												49.448,
												0.403
											],
											[
												55.087,
												0
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "a",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												10.977,
												0
											],
											[
												0,
												4.733
											],
											[
												-5.338,
												1.208
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-4.935,
												0
											],
											[
												0,
												-5.74
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												7.251
											]
										],
										"v": [
											[
												24.875,
												-6.042
											],
											[
												15.811,
												-13.394
											],
											[
												25.076,
												-21.854
											],
											[
												40.283,
												-25.177
											],
											[
												40.283,
												-19.034
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "a",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "a",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "i",
			"size": 19,
			"style": "Regular",
			"w": 42.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												16.617,
												-70.596
											],
											[
												16.617,
												-59.72
											],
											[
												25.882,
												-59.72
											],
											[
												25.882,
												-70.596
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "i",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												26.285,
												-50.354
											],
											[
												8.661,
												-50.354
											],
											[
												8.661,
												-42.7
											],
											[
												17.221,
												-42.7
											],
											[
												17.221,
												-7.654
											],
											[
												7.15,
												-7.654
											],
											[
												7.15,
												0
											],
											[
												35.449,
												0
											],
											[
												35.449,
												-7.654
											],
											[
												26.285,
												-7.654
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "i",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "i",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "r",
			"size": 19,
			"style": "Regular",
			"w": 48.7,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0.906,
												-0.101
											],
											[
												1.913,
												-5.64
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-10.373,
												0
											],
											[
												-0.806,
												-0.101
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-8.862,
												0.806
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-16.617
											],
											[
												1.108,
												0
											],
											[
												0,
												0
											],
											[
												-0.906,
												0
											]
										],
										"v": [
											[
												39.377,
												-51.462
											],
											[
												21.652,
												-40.887
											],
											[
												21.652,
												-50.354
											],
											[
												12.589,
												-50.354
											],
											[
												12.589,
												0
											],
											[
												21.652,
												0
											],
											[
												21.652,
												-23.062
											],
											[
												40.182,
												-43.103
											],
											[
												43.304,
												-43.002
											],
											[
												43.506,
												-51.562
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "r",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "r",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "e",
			"size": 19,
			"style": "Regular",
			"w": 58.5,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												3.021,
												4.834
											],
											[
												7.956,
												0
											],
											[
												4.431,
												-5.035
											],
											[
												0,
												-7.452
											],
											[
												-4.23,
												-4.733
											],
											[
												-7.755,
												0
											],
											[
												-2.216,
												11.783
											],
											[
												0,
												0
											],
											[
												8.56,
												0
											],
											[
												0.201,
												11.078
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-4.129,
												-6.546
											],
											[
												-7.251,
												0
											],
											[
												-4.23,
												4.733
											],
											[
												0,
												7.855
											],
											[
												4.33,
												5.035
											],
											[
												12.79,
												0
											],
											[
												0,
												0
											],
											[
												-1.208,
												7.654
											],
											[
												-9.467,
												0
											],
											[
												0,
												0
											],
											[
												0.403,
												-7.15
											]
										],
										"v": [
											[
												49.347,
												-41.592
											],
											[
												29.709,
												-51.562
											],
											[
												11.884,
												-44.009
											],
											[
												5.539,
												-25.278
											],
											[
												11.682,
												-6.143
											],
											[
												29.81,
												1.208
											],
											[
												52.872,
												-16.617
											],
											[
												44.11,
												-17.322
											],
											[
												29.709,
												-6.042
											],
											[
												15.408,
												-22.458
											],
											[
												53.577,
												-22.458
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "e",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-5.64,
												0
											],
											[
												-2.618,
												-3.827
											],
											[
												-0.101,
												-2.719
											],
											[
												0,
												0
											],
											[
												-1.813,
												3.021
											]
										],
										"o": [
											[
												5.438,
												0
											],
											[
												1.611,
												2.417
											],
											[
												0,
												0
											],
											[
												0,
												-2.518
											],
											[
												2.014,
												-3.323
											]
										],
										"v": [
											[
												29.81,
												-44.211
											],
											[
												41.592,
												-38.773
											],
											[
												44.312,
												-29.81
											],
											[
												15.509,
												-29.81
											],
											[
												17.926,
												-38.773
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "e",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "e",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": ".",
			"size": 19,
			"style": "Regular",
			"w": 41.7,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												26.587,
												0
											],
											[
												26.587,
												-11.783
											],
											[
												15.408,
												-11.783
											],
											[
												15.408,
												0
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": ".",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": ".",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": " ",
			"size": 19,
			"style": "Regular",
			"w": 42.2,
			"data": {},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "B",
			"size": 19,
			"style": "Regular",
			"w": 64,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												7.553,
												2.921
											],
											[
												0,
												6.949
											],
											[
												12.488,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												18.329
											]
										],
										"o": [
											[
												5.338,
												-2.921
											],
											[
												0,
												-17.624
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												13.394,
												0
											],
											[
												0,
												-8.661
											]
										],
										"v": [
											[
												48.541,
												-36.053
											],
											[
												57.404,
												-51.26
											],
											[
												30.917,
												-70.496
											],
											[
												8.963,
												-70.496
											],
											[
												8.963,
												0
											],
											[
												31.622,
												0
											],
											[
												59.821,
												-19.437
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												-11.38
											],
											[
												9.064,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												8.862,
												0
											],
											[
												0,
												11.179
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												30.212,
												-62.64
											],
											[
												48.541,
												-51.16
											],
											[
												30.212,
												-39.88
											],
											[
												17.926,
												-39.88
											],
											[
												17.926,
												-62.64
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 2,
								"ty": "sh",
								"ix": 3,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-12.589
											],
											[
												10.071,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												7.755,
												0
											],
											[
												0,
												11.682
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												17.926,
												-7.755
											],
											[
												17.926,
												-32.025
											],
											[
												32.126,
												-32.025
											],
											[
												50.958,
												-19.437
											],
											[
												31.622,
												-7.755
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "B",
						"np": 6,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "t",
			"size": 19,
			"style": "Regular",
			"w": 46.4,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-10.876,
												0
											],
											[
												-1.913,
												0.504
											],
											[
												0,
												0
											],
											[
												1.913,
												0
											],
											[
												0,
												4.028
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												2.618,
												0
											],
											[
												0,
												0
											],
											[
												-2.014,
												0.504
											],
											[
												-5.438,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												9.164
											]
										],
										"v": [
											[
												32.025,
												0.504
											],
											[
												39.478,
												-0.302
											],
											[
												39.276,
												-8.56
											],
											[
												32.73,
												-7.654
											],
											[
												25.378,
												-12.689
											],
											[
												25.378,
												-42.801
											],
											[
												39.679,
												-42.801
											],
											[
												39.679,
												-50.354
											],
											[
												25.378,
												-50.354
											],
											[
												25.378,
												-64.352
											],
											[
												16.415,
												-64.352
											],
											[
												16.415,
												-50.354
											],
											[
												5.841,
												-50.354
											],
											[
												5.841,
												-42.801
											],
											[
												16.415,
												-42.801
											],
											[
												16.415,
												-12.387
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "t",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "t",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "L",
			"size": 19,
			"style": "Regular",
			"w": 58.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												54.684,
												0
											],
											[
												54.684,
												-7.956
											],
											[
												19.336,
												-7.956
											],
											[
												19.336,
												-70.496
											],
											[
												10.272,
												-70.496
											],
											[
												10.272,
												0
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "L",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "L",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "n",
			"size": 19,
			"style": "Regular",
			"w": 59,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												3.928,
												4.129
											],
											[
												6.647,
												0
											],
											[
												2.518,
												-5.64
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-4.431,
												0
											],
											[
												-2.82,
												-2.82
											],
											[
												0,
												-4.633
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-3.625,
												-3.827
											],
											[
												-8.057,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-14.401
											],
											[
												2.82,
												0
											],
											[
												3.122,
												2.921
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-4.935
											]
										],
										"v": [
											[
												47.937,
												-45.923
											],
											[
												32.932,
												-51.562
											],
											[
												17.422,
												-42.7
											],
											[
												17.422,
												-50.354
											],
											[
												8.359,
												-50.354
											],
											[
												8.359,
												0
											],
											[
												17.422,
												0
											],
											[
												17.422,
												-27.795
											],
											[
												30.515,
												-44.009
											],
											[
												39.478,
												-41.089
											],
											[
												42.499,
												-29.407
											],
											[
												42.499,
												0
											],
											[
												51.865,
												0
											],
											[
												51.865,
												-29.91
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "n",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "n",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "k",
			"size": 19,
			"style": "Regular",
			"w": 55.9,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												52.469,
												0
											],
											[
												31.622,
												-31.924
											],
											[
												51.562,
												-50.354
											],
											[
												39.276,
												-50.354
											],
											[
												18.228,
												-29.507
											],
											[
												18.228,
												-70.496
											],
											[
												9.164,
												-70.496
											],
											[
												9.164,
												0
											],
											[
												18.228,
												0
											],
											[
												18.228,
												-19.235
											],
											[
												25.278,
												-25.882
											],
											[
												41.895,
												0
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "k",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "k",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "-",
			"size": 19,
			"style": "Regular",
			"w": 50.8,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												40.182,
												-24.472
											],
											[
												40.182,
												-32.529
											],
											[
												10.977,
												-32.529
											],
											[
												10.977,
												-24.472
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "-",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "-",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "f",
			"size": 19,
			"style": "Regular",
			"w": 46,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-5.035,
												0
											],
											[
												-1.913,
												-0.403
											],
											[
												0,
												0
											],
											[
												2.82,
												0
											],
											[
												0,
												-8.157
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-3.323
											],
											[
												1.913,
												0
											],
											[
												0,
												0
											],
											[
												-1.309,
												-0.302
											],
											[
												-10.977,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												26.385,
												0
											],
											[
												26.385,
												-42.801
											],
											[
												40.686,
												-42.801
											],
											[
												40.686,
												-50.354
											],
											[
												26.385,
												-50.354
											],
											[
												26.385,
												-58.713
											],
											[
												33.636,
												-62.943
											],
											[
												39.981,
												-62.338
											],
											[
												40.182,
												-70.395
											],
											[
												33.133,
												-70.999
											],
											[
												17.422,
												-58.914
											],
											[
												17.422,
												-50.354
											],
											[
												6.848,
												-50.354
											],
											[
												6.848,
												-42.801
											],
											[
												17.422,
												-42.801
											],
											[
												17.422,
												0
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "f",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "f",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "A",
			"size": 234,
			"style": "Bold",
			"w": 75.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												57.907,
												0
											],
											[
												74.02,
												0
											],
											[
												47.635,
												-70.496
											],
											[
												28.198,
												-70.496
											],
											[
												1.712,
												0
											],
											[
												17.12,
												0
											],
											[
												23.163,
												-16.718
											],
											[
												51.865,
												-16.718
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												27.695,
												-29.205
											],
											[
												37.463,
												-56.094
											],
											[
												47.232,
												-29.205
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "A",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": " ",
			"size": 234,
			"style": "Bold",
			"w": 17.8,
			"data": {},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "N",
			"size": 234,
			"style": "Bold",
			"w": 71.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												20.847,
												0
											],
											[
												20.041,
												-47.534
											],
											[
												50.354,
												0
											],
											[
												66.769,
												0
											],
											[
												66.769,
												-70.496
											],
											[
												50.958,
												-70.496
											],
											[
												51.764,
												-22.961
											],
											[
												21.451,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "N",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "N",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "E",
			"size": 234,
			"style": "Bold",
			"w": 58.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												55.087,
												0
											],
											[
												55.087,
												-12.891
											],
											[
												21.35,
												-12.891
											],
											[
												21.35,
												-29.608
											],
											[
												51.059,
												-29.608
											],
											[
												51.059,
												-41.592
											],
											[
												21.35,
												-41.592
											],
											[
												21.35,
												-57.806
											],
											[
												54.684,
												-57.806
											],
											[
												54.684,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "E",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "E",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "W",
			"size": 234,
			"style": "Bold",
			"w": 103.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												21.048,
												0
											],
											[
												39.478,
												0
											],
											[
												52.167,
												-52.67
											],
											[
												64.755,
												0
											],
											[
												83.084,
												0
											],
											[
												103.226,
												-70.496
											],
											[
												85.904,
												-70.496
											],
											[
												73.718,
												-20.242
											],
											[
												61.935,
												-70.496
											],
											[
												42.7,
												-70.496
											],
											[
												30.817,
												-20.242
											],
											[
												18.228,
												-70.496
											],
											[
												0.806,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "W",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "W",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "\u0003",
			"size": 234,
			"style": "Bold",
			"w": 0,
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "K",
			"size": 234,
			"style": "Bold",
			"w": 67.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												67.172,
												-70.496
											],
											[
												47.433,
												-70.496
											],
											[
												20.847,
												-40.988
											],
											[
												20.847,
												-70.496
											],
											[
												5.035,
												-70.496
											],
											[
												5.035,
												0
											],
											[
												20.847,
												0
											],
											[
												20.847,
												-20.444
											],
											[
												30.817,
												-31.219
											],
											[
												48.239,
												0
											],
											[
												66.669,
												0
											],
											[
												41.995,
												-43.304
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "K",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "K",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "I",
			"size": 234,
			"style": "Bold",
			"w": 27.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.841,
												0
											],
											[
												21.954,
												0
											],
											[
												21.954,
												-70.496
											],
											[
												5.841,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "I",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "I",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "D",
			"size": 234,
			"style": "Bold",
			"w": 72.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												20.746
											],
											[
												22.156,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												22.156,
												0
											],
											[
												0,
												-20.746
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												31.824,
												0
											],
											[
												69.489,
												-35.248
											],
											[
												31.824,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "D",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-13.193
											],
											[
												12.589,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												12.589,
												0
											],
											[
												0,
												13.193
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												21.149,
												-12.891
											],
											[
												21.149,
												-57.605
											],
											[
												31.622,
												-57.605
											],
											[
												53.073,
												-35.248
											],
											[
												31.622,
												-12.891
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "D",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "D",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "O",
			"size": 234,
			"style": "Bold",
			"w": 80.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-20.847,
												0
											],
											[
												0,
												20.847
											],
											[
												20.847,
												0
											],
											[
												0,
												-20.746
											]
										],
										"o": [
											[
												21.048,
												0
											],
											[
												0,
												-21.048
											],
											[
												-20.847,
												0
											],
											[
												0,
												21.048
											]
										],
										"v": [
											[
												40.384,
												2.014
											],
											[
												77.646,
												-35.248
											],
											[
												40.384,
												-72.51
											],
											[
												3.122,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												11.581,
												0
											],
											[
												0,
												13.193
											],
											[
												-11.581,
												0
											],
											[
												0,
												-13.293
											]
										],
										"o": [
											[
												-11.783,
												0
											],
											[
												0,
												-13.495
											],
											[
												11.783,
												0
											],
											[
												0,
												13.394
											]
										],
										"v": [
											[
												40.384,
												-12.488
											],
											[
												19.537,
												-35.248
											],
											[
												40.384,
												-58.109
											],
											[
												61.23,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "O",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "F",
			"size": 234,
			"style": "Bold",
			"w": 54.7,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												21.35,
												0
											],
											[
												21.35,
												-27.997
											],
											[
												50.354,
												-27.997
											],
											[
												50.354,
												-40.485
											],
											[
												21.35,
												-40.485
											],
											[
												21.35,
												-57.605
											],
											[
												52.368,
												-57.605
											],
											[
												52.368,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "F",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "F",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "B",
			"size": 234,
			"style": "Bold",
			"w": 65.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												11.38
											],
											[
												8.963,
												1.611
											],
											[
												0,
												7.05
											],
											[
												13.394,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												13.495,
												0
											],
											[
												0,
												-8.661
											],
											[
												7.15,
												-1.913
											],
											[
												0,
												-11.581
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												39.679,
												0
											],
											[
												62.54,
												-19.235
											],
											[
												48.038,
												-35.751
											],
											[
												60.123,
												-50.858
											],
											[
												37.363,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-4.935
											],
											[
												5.338,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												5.338,
												0
											],
											[
												0,
												5.035
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												20.847,
												-41.492
											],
											[
												20.847,
												-58.31
											],
											[
												35.55,
												-58.31
											],
											[
												44.614,
												-49.951
											],
											[
												35.55,
												-41.492
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 2,
								"ty": "sh",
								"ix": 3,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-5.035
											],
											[
												5.237,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												5.237,
												0
											],
											[
												0,
												5.136
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												20.847,
												-12.387
											],
											[
												20.847,
												-29.507
											],
											[
												37.766,
												-29.507
											],
											[
												46.628,
												-20.947
											],
											[
												37.766,
												-12.387
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "B",
						"np": 6,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "U",
			"size": 234,
			"style": "Bold",
			"w": 69,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-18.228,
												0
											],
											[
												0,
												17.624
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												8.862,
												0
											],
											[
												0,
												9.668
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												18.228,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												9.668
											],
											[
												-8.862,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												17.624
											]
										],
										"v": [
											[
												34.744,
												1.41
											],
											[
												65.46,
												-28.198
											],
											[
												65.46,
												-70.496
											],
											[
												49.146,
												-70.496
											],
											[
												49.146,
												-28.702
											],
											[
												34.744,
												-13.092
											],
											[
												20.343,
												-28.702
											],
											[
												20.343,
												-38.672
											],
											[
												20.343,
												-70.496
											],
											[
												4.028,
												-70.496
											],
											[
												4.028,
												-38.672
											],
											[
												4.028,
												-28.198
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "U",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "U",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "Y",
			"size": 234,
			"style": "Bold",
			"w": 68.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												26.385,
												0
											],
											[
												42.599,
												0
											],
											[
												42.599,
												-23.969
											],
											[
												68.179,
												-70.496
											],
											[
												50.253,
												-70.496
											],
											[
												34.543,
												-41.089
											],
											[
												18.933,
												-70.496
											],
											[
												0.806,
												-70.496
											],
											[
												26.385,
												-23.969
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "Y",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "Y",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "S",
			"size": 129,
			"style": "Bold",
			"w": 62,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-16.718,
												0
											],
											[
												0,
												13.495
											],
											[
												15.207,
												2.921
											],
											[
												0,
												0
											],
											[
												0,
												4.23
											],
											[
												-6.244,
												0
											],
											[
												-0.201,
												-7.15
											],
											[
												0,
												0
											],
											[
												15.811,
												0
											],
											[
												0,
												-13.193
											],
											[
												-14.905,
												-2.921
											],
											[
												0,
												0
											],
											[
												0,
												-3.827
											],
											[
												6.647,
												0
											],
											[
												0,
												7.251
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												16.415,
												0
											],
											[
												0,
												-11.38
											],
											[
												0,
												0
											],
											[
												-4.935,
												-1.007
											],
											[
												0,
												-4.935
											],
											[
												6.949,
												0
											],
											[
												0,
												0
											],
											[
												-0.403,
												-13.998
											],
											[
												-15.912,
												0
											],
											[
												0,
												11.783
											],
											[
												0,
												0
											],
											[
												4.733,
												1.007
											],
											[
												0,
												5.035
											],
											[
												-7.755,
												0
											],
											[
												0,
												0
											],
											[
												0,
												14.2
											]
										],
										"v": [
											[
												31.219,
												1.913
											],
											[
												59.015,
												-20.847
											],
											[
												36.456,
												-42.096
											],
											[
												28.5,
												-43.607
											],
											[
												20.947,
												-51.663
											],
											[
												31.622,
												-59.921
											],
											[
												43.707,
												-47.736
											],
											[
												59.619,
												-48.642
											],
											[
												32.126,
												-72.409
											],
											[
												5.035,
												-50.153
											],
											[
												26.99,
												-28.4
											],
											[
												34.946,
												-26.889
											],
											[
												42.902,
												-19.336
											],
											[
												31.723,
												-10.776
											],
											[
												18.631,
												-23.163
											],
											[
												2.82,
												-22.156
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "S",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "S",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "H",
			"size": 129,
			"style": "Bold",
			"w": 69.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												21.35,
												0
											],
											[
												21.35,
												-29.306
											],
											[
												48.541,
												-29.306
											],
											[
												48.541,
												0
											],
											[
												64.755,
												0
											],
											[
												64.755,
												-70.496
											],
											[
												48.541,
												-70.496
											],
											[
												48.541,
												-42.096
											],
											[
												21.35,
												-42.096
											],
											[
												21.35,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "H",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "H",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./assets/animations/New_kind_of_buy_spin.json
// module id = 49
// module chunks = 0